import { Box, Icon } from "@chakra-ui/react";
import SortIcon from "../icons/SortIcon";
import React from "react";

/**
 * ReactiveHeader component that renders a table header with a reactive design.
 * The header adapts its style based on the type of data it displays (e.g., dollar value or regular string).
 * It also supports sorting and resizing functionalities.
 *
 * @component
 * @param {Object} data - The data object containing header information.
 * @param {string} data.type - The type of header, can be "main" or "sub".
 * @param {Object} data.header - The header object containing column definitions and methods.
 * @param {number} data.index - The index of the header in the table.
 * @param {boolean} [data.fill=true] - A flag to determine if the header should be filled.
 * @param {Array} data.date - An array containing date information for metrics.
 *
 * @returns {JSX.Element} The rendered ReactiveHeader component.
 * @example
 * return (
 *  <ReactiveHeader data={data} />
 * )
 */
const ReactiveHeader = (data) => {

  const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];

  var dark = "th-mid";
  var mid = "";

  if (data.type === "main") {
    dark = "th-main-dark";
    mid = "th-main-mid";
  } else if (data.type === "sub") {
    dark = "th-mid";
    mid = "";
  }

  const { header, index } = data;

  if (data.fill !== false) {
    return (
      <Box className={index !== 0 && index % 2 !== 0 ? `th ${dark}` : `th ${mid}`} w={header.getSize() - 3} key={header.id} fontWeight='semibold'>
        {index === 0 ?
          <Box pl={4}>{header.column.columnDef.header}</Box> : null
        }
        {index !== 0 ?
          <Box className="total" ml="auto" mr={0}>{header.column.columnDef.header}</Box> : null
        }
        {index === 0 ?
          <Box ml="auto" mr={10}>{
            header.column.getCanSort() && <Icon
              as={SortIcon}
              fontSize={14}
              onClick={
                header.column.getToggleSortingHandler()
              }
            />
          }</Box> : null
        }
        {index !== 0 ?
          <Box>{
            header.column.getCanSort() && <Icon
              as={SortIcon}
              pt={1}
              mr="auto"
              ml={1}
              fontSize={18}
              onClick={
                header.column.getToggleSortingHandler()
              }
            />
          }</Box> : null
        }

        <Box
          onMouseDown={
            header.getResizeHandler()
          }
          onTouchStart={
            header.getResizeHandler()
          }
          className={
            `resizer ${header.column.getIsResizing() ? "isResizing" : ""
            }`
          }
        />
      </Box>
    );
  };

  return (
    <Box className={index !== 0 && index % 2 !== 0 ? "th th-mid" : "th"} w={header.getSize() - 3} key={header.id} fontWeight='semibold'>
      <p key={"metricsDate" + index}>{data.date[0][days[index - 1]]}</p>
      <Box
        onMouseDown={
          header.getResizeHandler()
        }
        onTouchStart={
          header.getResizeHandler()
        }
        className={
          `resizer ${header.column.getIsResizing() ? "isResizing" : ""
          }`
        }
      />
    </Box>
  )
};

export default ReactiveHeader;
